import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = unauthenticated, object = user

  useEffect(() => {
    const t = localStorage.getItem("token");
    if (!t) { setUser(false); return; }
    api.me().then(setUser).catch(() => { localStorage.removeItem("token"); setUser(false); });
  }, []);

  const login = async (email, password) => {
    const d = await api.login({ email, password });
    localStorage.setItem("token", d.token);
    setUser(d.user);
    return d;
  };
  const register = async (email, password, name) => {
    const d = await api.register({ email, password, name });
    localStorage.setItem("token", d.token);
    setUser(d.user);
    return d;
  };
  const logout = () => {
    localStorage.removeItem("token");
    setUser(false);
    window.location.href = "/login";
  };

  return <AuthCtx.Provider value={{ user, setUser, login, register, logout }}>{children}</AuthCtx.Provider>;
}
